import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filterOutlets: [],
    filterTypes: [],
    lastQuery: null,
    appList: [],
    outletList: [],
    searchMeta: null,
    filters: [],
};

const mutations = {
    setFilterOutlets(state, types) {
        state.filterOutlets = types;
    },

    setFilterTypes(state, types) {
        state.filterTypes = types;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setAppList(state, data) {
        state.appList = data;
    },

    setOutletList(state, data) {
        state.outletList = data;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },
};

const getters = {
    filterOutlets: state => {
        return state.filterOutlets;
    },

    filterTypes: state => {
        return state.filterTypes;
    },

    filters(state) {
        return state.filters;
    },
};

const actions = {
    getAppList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-app');

        return axios
            .get(Laroute.route('franchise.vue.marketplace-apps'), options)
            .then(res => {
                let data = res.data.data;

                commit('setAppList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-app');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-app');

                throw err;
            });
    },

    getAppListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.appList.length || state.lastQuery !== params.query) {
            return dispatch('getAppList', params);
        }

        return Promise.resolve(state.appList);
    },

    async getAppListFilter({ commit }, { query }) {
        const response = await axios.get(
            Laroute.route('franchise.vue.marketplace-apps'),
            {
                params: { query, limit: 1000 },
            },
        );

        return response.data.data.map(d => ({
            id: d.id,
            display_name: d.name,
        }));
    },

    getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-outlet');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                let data = res.data.data;

                commit('setOutletList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-outlet');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-outlet');

                throw err;
            });
    },

    getOutletListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.appList.length || state.lastQuery !== params.query) {
            return dispatch('getOutletList', params);
        }

        return Promise.resolve(state.appList);
    },

    getStatusFilter({ commit }, { query }) {
        return [
            { id: 'unsubscribed', display_name: 'Expired' },
            { id: 'subscribed', display_name: 'Paid' },
            { id: 'pending_payment', display_name: 'Pending' },
            { id: 'payment_failed', display_name: 'Failed' },
        ];
    },

    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route('franchise.subscription.search.meta');

        startLoading(dispatch, 'get-subscription-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-subscription-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-subscription-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/marketplace-app.js